import React from 'react'
import PropTypes from 'prop-types'
import { SearchIcon } from '@heroicons/react/outline'
import clsx from 'clsx'

const SearchInput = ({
    value,
    setValue,
    name,
    placeholder,
    additionalClassName,
}) => {
    const onChange = e => {
        const value = e?.target.value
        setValue(value)
    }

    return (
        <div
            className={clsx(
                'flex flex-row items-center justify-start h-12 overflow-hidden',
                additionalClassName,
            )}
        >
            <label
                htmlFor={name}
                className="px-3.5 h-full flex items-center justify-center bg-grayLines rounded-tl-xl rounded-bl-xl"
            >
                <SearchIcon
                    aria-label={placeholder}
                    className="w-4 h-4 stroke-current text-textDarkerGray stroke-2"
                />
            </label>
            <input
                onChange={onChange}
                name={name}
                placeholder={placeholder}
                id={name}
                type="text"
                value={value}
                className="px-2 font-normal h-full flex-grow text-sm outline-none text-textDarkerGray placeholder-textDarkGray inputSearch "
            />
        </div>
    )
}

SearchInput.propTypes = {
    value: PropTypes.string,
    setValue: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    additionalClassName: PropTypes.string,
}

export default SearchInput
